import axios from 'axios';

export const _post = async (body: any): Promise<any> => {
  return await axios.post('', body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _postFormData = async (body: any): Promise<any> => {
  return await axios.post('', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const _postAllHeaders = async (payload: any): Promise<any> => {
  return await axios.post('', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _delete = async (payload: any): Promise<any> => {
  return await axios.delete('', {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _get = async (params: any): Promise<any> => {
  return await axios.get(params.route || '', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _put = async (data: any): Promise<any> => {
  return await axios.put('', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _getArgosV25 = async (data: any): Promise<any> => {
  return await axios.get(`https://argos-v25.itmsol.fr/${data.route}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const _postArgosV25 = async (data: any): Promise<any> => {
  return await axios.post(
    `https://argos-v25.itmsol.fr/${data.route}`,
    data.payload ? data.payload : undefined,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};
export const _putArgosV25 = async (data: any): Promise<any> => {
  return await axios.put(
    `https://argos-v25.itmsol.fr/${data.route}`,
    data.payload ? data.payload : undefined,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};
export const _deleteArgosV25 = async (data: any): Promise<any> => {
  return await axios.delete(`https://argos-v25.itmsol.fr/${data.route}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
